<template>
  <!-- <b-navbar toggleable="md" fixed="top" type="dark" variant="dark"> -->
  <b-navbar  class="c">
    <b-container fluid>
      <!-- <b-navbar-brand :to="{name: 'home'}">VectorByte</b-navbar-brand> -->
      <img
        src="@/assets/images/logos/VectorByte-logo-4k.png"
        class="mr-3"
        width=40px
        @click="goTo('https://www.vectorbyte.org/')"
        style="cursor: pointer;"
      />

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav>
         
          <b-nav-item href="https://www.vectorbyte.org/">Home</b-nav-item>
          <b-nav-item href="https://www.vectorbyte.org/our-team">Our Team</b-nav-item>
          <b-nav-item href="https://www.vectorbyte.org/faqs">FAQs</b-nav-item>
          <b-nav-item href="https://www.vectorbyte.org/blog">Blog</b-nav-item>
          <b-nav-item-dropdown text="Databases" toggle-class="drop-down-toggle" left :no-caret="false">
            <b-dropdown-item :to="{name: 'vecdyn-datasets'}">VecDyn</b-dropdown-item>
            <b-dropdown-divider></b-dropdown-divider>
            <b-dropdown-item :to="{name: 'vectraits-explorer'}">VecTraits</b-dropdown-item>
            <b-dropdown-divider></b-dropdown-divider>
            <b-dropdown-item href="https://www.vectorbyte.org/vecdataecosystem">VectorData Ecosystem</b-dropdown-item>
          </b-nav-item-dropdown>

        </b-navbar-nav>

        <b-navbar-nav class="ml-auto">
          <!-- Conditionally displayed drop-down for VecDyn data -->
          <b-nav-item-dropdown text="VecDyn Administration" toggle-class="drop-down-toggle" right v-if="admin_authorized">
            <b-dropdown-item :to="{name: 'submit-vecdyn'}">Upload VecDyn Data</b-dropdown-item>
            <b-dropdown-divider></b-dropdown-divider>
            <b-dropdown-item :to="{name: 'curate-vecdyn'}">Curate VecDyn Data</b-dropdown-item>
            <b-dropdown-divider></b-dropdown-divider>
            <b-dropdown-item :to="{name: 'assay-types'}">Assay Types</b-dropdown-item>
            <b-dropdown-item :to="{name: 'assay-protocols'}">Assay Protocols</b-dropdown-item>
            <b-dropdown-divider></b-dropdown-divider>
            <b-dropdown-item
              v-if="is_admin"
              :to="{name: 'admin-logs', query: {app_type: 'vecdyn'}}"
            >
              View Logs
            </b-dropdown-item>
            <b-dropdown-divider v-if="is_admin"></b-dropdown-divider>
            <b-dropdown-item :to="{name: 'user'}">Profile</b-dropdown-item>
            <b-dropdown-divider></b-dropdown-divider>
            <b-dropdown-item @click="logout()">Sign Out</b-dropdown-item>
          </b-nav-item-dropdown>

          <b-nav-item-dropdown toggle-class="drop-down-toggle" 
          right v-if="!admin_authorized && JSON.stringify(user) !== '{}'">
            <template slot="button-content">
              <span v-if="user.username">{{ user.username }}</span>
              <span v-else>Logged In</span>
            </template>
            <b-dropdown-item :to="{name: 'user'}">Profile</b-dropdown-item>
            <b-dropdown-divider></b-dropdown-divider>
            <b-dropdown-item @click="logout()">Sign Out</b-dropdown-item>
          </b-nav-item-dropdown>

          <b-nav-item
            v-if="!user.username"
            :to="{name: 'login', query: this.nextUrlQueryParams}"
          >
            Sign Up/Sign In
          </b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-container>
  </b-navbar>
</template>

<script>
// import store from '../../store/store';
import { mapActions, mapState } from "vuex";
import * as _ from "lodash";

export default {
  data() {
    return {
      // admin_authorized: false,
    };
  },
  computed: {
    ...mapState("user", ["user", "myGroups"]),
    admin_authorized : function() {
      const that = this;
      // store.getters['user/inMyGroups'](['admin', 'uploader', 'collaborator'])
      let groups = ['admin', 'uploader', 'collaborator'];
      return Boolean((_.intersection(that.myGroups, groups)).length);
    },
    is_admin : function() {
      return this.myGroups.includes('admin');
    },
    currentPage : function() {
      return window.location.pathname;
    },
    nextUrlQueryParams : function() {
      let params = {};

      params['next'] = this.currentPage;
      _.merge(params, this.$route.query);

      return params;
    },
  },
  mounted() {
    // Check if user has special priviledges. If so, we will display a drop-down in the nav.
    // this.admin_authorized = store.getters['user/inMyGroups'](['admin', 'uploader', 'collaborator']);
  },
  methods: {
    ...mapActions([
      "setBaseComponent",
      "clearAuthorizationToken",
    ]),
    ...mapActions("user", ["setUser", "setMyGroups"]),
    // goTo(route) {
    //   this.$router.push(route);
    // },
    goTo(route) {
      window.location.href = route;
    },
    toggle: function() {
      this.drawer = !this.drawer;
    },
    logout: function() {
      this.clearAuthorizationToken();
      this.setUser({});
      this.setMyGroups([]);

      this.$notify({
        text: "You have been logged out",
        duration: 10000,
        type: "warn"
      });

      // This is sending the user to the home page which is not being redirected to squarespace...
      // Remove this in favor of just using window.location.href
      // this.$router.push({
      //   name: "home"
      // });
      window.location.href = "https://www.vectorbyte.org/";
    },
    redirectToSignUp() {
      window.location.href = `${process.env.VUE_APP_AXIOS_BASE_URL}/accounts/signup/`;
    },
  }
};
</script>

<style>
  .b {
    background-color: #fcf6eb !important;
  }

  .drop-down-toggle {
    background-color: #fcf6eb !important;
  }

  /* .dropdown-toggle::after { */
    /* I had to add the following 4 rules to override whatever was causing the
    caret to be displayed in the middle of the label */
    /* display: inline-block !important;
    position: relative !important;
    right: 0 !important;
    top: 0 !important; */
    /* ------ */
    /* width: 0;
    height: 0;
    margin-left: .3em;
    vertical-align: middle;
    content: "";
    border-top: .3em solid;
    border-right: .3em solid transparent;
    border-left: .3em solid transparent;
    list-style: none; */
/* } */
</style>